// ============================================================================
// FRENCH TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Faits bibliques intéressants

export const bibleFacts = [
  {
    category: "statistiques",
    text: "La Bible contient 31 173 versets au total",
    source: "Analyse textuelle des manuscrits"
  },
  {
    category: "langues",
    text: "La Bible a été traduite en plus de 3000 langues différentes",
    source: "Sociétés bibliques unies"
  },
  {
    category: "rédaction",
    text: "La Bible a été écrite sur environ 1600 ans par 40 auteurs différents",
    source: "Études historiques bibliques"
  },
  {
    category: "structure",
    text: "Le psaume 119 est le plus long chapitre avec 176 versets",
    source: "Structure canonique"
  },
  {
    category: "records",
    text: "Le verset le plus court en français est 'Jésus pleura' (Jean 11:35)",
    source: "Analyse textuelle"
  },
  {
    category: "symbolisme",
    text: "Le nombre 7 symbolise la perfection et apparaît 735 fois",
    source: "Études numériques bibliques"
  },
  {
    category: "vocabulaire",
    text: "Le mot 'amour' sous diverses formes apparaît plus de 500 fois",
    source: "Concordance biblique"
  }
];

export default bibleFacts;
